import { allTrackers } from "app/services/track/track";
import type { track as TrackType } from "pro-features/components/WithTrack/src/context";

type QuickSearchTracking = {
    trackClickOnSearchBar: () => void;
    trackSearchPopupOpen: (withAI: boolean) => void;
    trackSearchPopupClose: () => void;
    trackSearchItemClick: (itemType: "website" | "keyword" | "report", itemName: string, state?: string) => void;
    trackSelectTab: (tab: string) => void;
    trackUserQuery: (query: string, tab: string) => void;
    trackReportNavigationFailed: (itemName: string, resolvedUrl: string) => void;
    trackAIAssistantClick: (query: string) => void;
};

const createQuickSearchTracking = (track: TrackType): QuickSearchTracking => ({
    trackClickOnSearchBar: () => {
        track("Sidebar Interaction", "click", "quick_search");
    },
    trackSearchPopupOpen: (withAI) => {
        track("popup", "open", `quick_search/${withAI ? "with AI assistant" : "without AI assistant"}`);
    },
    trackSearchPopupClose: () => {
        track("popup", "close", "quick_search");
    },
    trackSearchItemClick: (itemType, itemName, state) => {
        track("popup", "click", `${state}/${itemType.toUpperCase()}/${itemName}`);
    },
    trackSelectTab: (tab: string) => {
        track("popup", "click", `select_tab/${tab}_results`);
    },
    trackUserQuery: (query: string, tab: string) => {
        track("popup", "click", `search_result/${tab}/${query}`);
    },
    trackReportNavigationFailed: (itemName, resolvedUrl) => {
        track("popup", "error", `report_navigation_failed/${itemName}/${resolvedUrl}`);
    },
    trackAIAssistantClick: (query) => {
        track("popup", "click", `quick_search/AI Assistant query/${query}`);
    },
});

export default createQuickSearchTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
